import React, { useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "src/components/providers/auth-context";
import PropTypes from "prop-types";
import useQueryParams from "src/hooks/use-query-params";
import Auth from "src/services/auth";
import { CircularProgress } from "@mui/material";

const ProtectedRouteInner = ({ location, children }) => {
    const { isError, jwt, idToken } = useAuth();
    const { pathname } = useLocation();
    const query = useQueryParams();
    const navigate = useNavigate();
    const code = query.get("code");

    useEffect(() => {
        if (!code && !jwt) {
            if (Auth.user || Auth.jwt || Auth.token) {
                Auth.redirectToLogin(window.location.href);
            } else {
                navigate("/login");
            }
        } else if (!code && jwt) {
            if (
                idToken &&
                idToken.mergedIdentity &&
                !idToken.loginMethodVerified &&
                pathname !== "roadblock"
            ) {
                navigate("/roadblock");
            }
        }
    }, [code, jwt]);

    if (!code && !jwt) {
        return null;
    }

    if (isError) return <Navigate to={{ pathname: "/login", state: { from: location } }} />;

    // if (!isProfileComplete && !isOnboardingRoute) {
    //   return <Navigate to={isSuperAdmin ? "/welcome" : "/user-setup"} />;
    // }

    return children;
};

ProtectedRouteInner.propTypes = {
    location: PropTypes.shape(),
};

ProtectedRouteInner.defaultProps = {
    location: undefined,
};

const ProtectedRoute = (props) => {
    const { isLoading, authStarted } = useAuth();
    const query = useQueryParams();
    const location = useLocation();
    const error = query.get("error");

    if (isLoading || !authStarted)
        return (
            <div
                style={{
                    width: "100vw",
                    height: "100vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 9999,
                    position: "absolute",
                    top: 0,
                }}
            >
                <CircularProgress size={150} />
            </div>
        );

    if (error === "access_denied" && location.pathname !== "/integrations/slack/oauth") {
        return <Navigate to="/" />;
    }

    return <ProtectedRouteInner {...props} />;
};

export default ProtectedRoute;
